/*
 * tt-density.js
 * ---------------------------------------------------------------
 * Frontend grid density toggle for collection + search pages.
 * Clicking 4/6/8/10 swaps the grid--N-col-desktop class on the
 * product grid <ul> and persists the choice in localStorage so
 * the user's preference sticks across page loads.
 *
 * Re-applies after Dawn's facet form replaces #product-grid
 * (filter / sort) and works alongside tt-infinite-scroll.js
 * (newly-appended items inherit the UL's current class).
 */
(function () {
  var STORAGE_KEY = 'tt_density_cols';
  var GRID_CLASS_RE = /grid--\d+-col-desktop/;

  function getList(host) {
    if (!host) return null;
    if (host.tagName === 'UL') return host;
    return host.querySelector('ul.product-grid, ul.grid, ul');
  }

  function applyDensity(list, cols) {
    if (!list) return;
    if (GRID_CLASS_RE.test(list.className)) {
      list.className = list.className.replace(GRID_CLASS_RE, 'grid--' + cols + '-col-desktop');
    } else {
      list.classList.add('grid--' + cols + '-col-desktop');
    }
  }

  function syncButtons(toggle, cols) {
    toggle.querySelectorAll('[data-tt-density]').forEach(function (b) {
      b.classList.toggle('is-active', String(cols) === b.getAttribute('data-tt-density'));
    });
  }

  function applyStoredTo(toggle) {
    var targetId = toggle.getAttribute('data-tt-density-target') || 'product-grid';
    var host = document.getElementById(targetId);
    var list = getList(host);
    if (!list) return;
    var stored = 0;
    try { stored = parseInt(localStorage.getItem(STORAGE_KEY), 10); }
    catch (e) { /* storage blocked (private mode) — fall through to current */ }
    var match = list.className.match(/grid--(\d+)-col-desktop/);
    var current = match ? parseInt(match[1]) : 6;
    var cols = stored || current;
    if (stored && stored !== current) applyDensity(list, cols);
    syncButtons(toggle, cols);
  }

  function wire(toggle) {
    if (toggle.__ttWired) return;
    toggle.__ttWired = true;
    toggle.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-tt-density]');
      if (!btn) return;
      var cols = parseInt(btn.getAttribute('data-tt-density'));
      if (!cols) return;
      var host = document.getElementById(toggle.getAttribute('data-tt-density-target') || 'product-grid');
      var list = getList(host);
      applyDensity(list, cols);
      try { localStorage.setItem(STORAGE_KEY, String(cols)); } catch (err) {}
      syncButtons(toggle, cols);
    });
  }

  function init() {
    document.querySelectorAll('[data-tt-density-toggle]').forEach(function (toggle) {
      wire(toggle);
      applyStoredTo(toggle);
    });
  }

  // Re-apply after Dawn facet replacement of #product-grid.
  function watchForReplacement() {
    var mo = new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        for (var j = 0; j < muts[i].addedNodes.length; j++) {
          var n = muts[i].addedNodes[j];
          if (n.nodeType !== 1) continue;
          if (n.id === 'product-grid' || (n.querySelector && n.querySelector('#product-grid'))) {
            init();
            return;
          }
        }
      }
    });
    mo.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); watchForReplacement(); });
  } else { init(); watchForReplacement(); }
})();
